/** Admin calculator customization routes. Add child paths under this base. */
export const CALCULATOR_SETTINGS_BASE = 'calculator-settings';

export const CALCULATOR_SETTINGS_DESTINATIONS_PATH = `${CALCULATOR_SETTINGS_BASE}/destinations`;

export const CALCULATOR_SETTINGS_VEHICLE_TYPES_PATH = `${CALCULATOR_SETTINGS_BASE}/vehicle-types`;

export const CALCULATOR_SETTINGS_ENGINE_TYPES_PATH = `${CALCULATOR_SETTINGS_BASE}/engine-types`;

/** Previous URL segment; keep redirects in App.js. */
export const LEGACY_GEORGIAN_CALCULATOR_SETTINGS_BASE = 'georgian-calculator-settings';
